import { FC } from 'react';

import { IconProps } from '../types';

export const GoogleNewsIcon: FC<IconProps> = ({
	size,
	height = 16,
	width = 20,
	color = '#06519E',
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 20 16"
		width={size ?? width}
		height={size ?? height}
	>
		<path
			fill={color}
			fillRule="evenodd"
			d="M14.375 2.613V.456a.458.458 0 0 0-.459-.455H4.203a.458.458 0 0 0-.462.456v2.125L10.034.293a.445.445 0 0 1 .556.292L11 1.71l3.376.904Zm3.371 1.255-6.602-1.776.564 1.55h4.188a.46.46 0 0 1 .46.459v6.596l1.684-6.275a.444.444 0 0 0-.294-.554ZM9.83.736a.446.446 0 0 1 .557.287l.952 2.618H2.222a.462.462 0 0 0-.46.46v5.256L.095 4.773a.445.445 0 0 1 .242-.581L9.829.736Zm6.18 13.524a.46.46 0 0 1-.459.46H2.568a.46.46 0 0 1-.46-.46V4.447a.46.46 0 0 1 .46-.46H15.55a.46.46 0 0 1 .46.46v9.813Zm-2.273-2.564v-.897a.06.06 0 0 0-.06-.06h-4.03v1.021h4.03a.061.061 0 0 0 .06-.064Zm.613-1.94v-.902a.06.06 0 0 0-.06-.061H9.647v1.021h4.642a.06.06 0 0 0 .06-.06v.001Zm-.613-1.941V6.91a.06.06 0 0 0-.06-.06h-4.03v1.02h4.03c.033 0 .06-.026.06-.059v.004Zm-7.564 1.08v.918H7.5c-.11.562-.604.97-1.328.97a1.482 1.482 0 0 1 0-2.962c.35-.006.687.126.94.367l.7-.7a2.355 2.355 0 0 0-1.64-.639 2.451 2.451 0 1 0 0 4.903c1.417 0 2.35-.996 2.35-2.398-.002-.156-.015-.31-.04-.464l-2.31.004Z"
		/>
	</svg>
);
